<template>
  <div class="page p-viewpoint">
    <div class="page__head">
      <page-header :back-location="localePath({ name: 'viewpoint' })" title="page_wizard.title" />
    </div>
    <div class="page__main page__main--contain">
      <interstitial-content
        :facets="['as-interstitial']"
        :image="interstitialContent.image"
        :text="interstitialContent.text"
      >
        <template #cta-link>
          <n-link
            :to="localePath({ name: 'wizard-step-step', params: { step: 'centering' } })"
            class="p-viewpoint__link u-reset"
          >
            <responsive-img
              :width="41"
              alt=""
              src="/images/arrow_icons/custom/arrow_right_pos@3x.png"
            />
          </n-link>
        </template>
      </interstitial-content>
    </div>
  </div>
</template>

<script>
  import PageHeader from '@/components/page-header/page-header'
  import InterstitialContent from '@/components/interstitial-content/interstitial-content'
  import {
    interstitialContentIds,
    interstitialContentList,
  } from '@/assets/js/model/interstitial-content'
  import { personaList } from '@/assets/js/model/persona'
  import { pageThemes } from '@/assets/js/model/page-theme'
  import ResponsiveImg from '@/components/responsive-img/responsive-img'

  export default {
    meta: {
      titleKey: 'meta.wizard.title',
    },
    components: { ResponsiveImg, InterstitialContent, PageHeader },
    computed: {
      persona() {
        return personaList.find(({ param }) => param === this.$route.params.persona)
      },
      pageTheme() {
        return pageThemes.find(({ id }) => id === this.persona.pageThemeId)
      },
      interstitialContent() {
        return interstitialContentList.find(({ id }) => {
          return id === interstitialContentIds.CUSTOM_WIZARD_INTRODUCTION
        })
      },
    },
  }
</script>

<style lang="scss" src="@/assets/scss/pages/_p-viewpoint.scss" />
